module.exports = __webpack_public_path__ + "static/img/logoxd.0c20adef.jpg";